import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {getPublicIP} from '../../../utils/url';
import {EvaluationV2Template} from '../../templates/evaluation-v2.template';
import {executeUserCreditCheckService} from '../../../services/new-services/application-v2.services';
import {useAnalytics} from "../../../hooks/useAnalytics.js";
import {jwtDecode} from "jwt-decode";
import {createWebLogRecord} from "../../../services/new-services/analytics.service.js";

export const EvaluationScreen = () => {
    
    const authToken = useSelector((state) => state.applicationProcess.authToken);
    const sessionId = useSelector((state) => state.applicationProcess.sessionId);
    const [processing, setProcessing] = useState(false);

    async function handleSubmit() {
        if (processing) return;
        const decodedToken = jwtDecode(authToken);
        const userId = decodedToken.id;
        console.log("Decoded JWT Payload:", decodedToken);

        // create application
        const deviceInfo = {
            contacts: {total: -1, unique: -1},
            location: {latitude: -1, longitude: -1},
        };
        await executeUserCreditCheckService(
            authToken,
            deviceInfo,
            await getPublicIP(),
        );
        createWebLogRecord(sessionId, userId, {}, false, true, 'USER_CREDIT_CHECK_START');
        createWebLogRecord(sessionId, userId, {}, false, true, 'USER_CREDIT_CHECK_END');
        setProcessing(true);
    }

    useEffect(() => {
        handleSubmit();
    }, []);

    return (
        <div style={styles.mainContainerStyle}>
            <EvaluationV2Template/>
        </div>
    );
};

const styles = {
    mainContainerStyle: {
        margin: '0 auto',
        padding: window.innerWidth > 700 ? '0 25%' : '0'
    }
}